import Vue from 'vue'

export default {
  setZoneGroupPeriod(state, data) {
    if(data && state.zoneGroupPeriods && state.zoneGroupPeriods.borders[0] === data.borders[0]) {
      state.zoneGroupPeriods.selectedIntervals = data.selectedIntervals
    } else {
      state.zoneGroupPeriods = data
    }
  },
  setZoneGroupToEdit(state, data) {
    state.zoneGroupToEdit = data
  },
  setZoneGroupInfo(state, data) {
    state.zoneGroupInfo = data
  },
  setZoneGroupZoneInfo(state, data) {
    state.zoneGroupZoneInfo = data
  },
  setZoneGroupMap(state, data) {
    state.zoneGroupMap = data
  },
  setZoneGroupMapAction(state, data) {
    state.zoneGroupMapAction = data
  },
}



// WEBPACK FOOTER //
// ./src/store/zonegroups/mutations.js